import { useState } from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material'

function AgendaButton({ Icon, onClick, agendas = [] }) {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    if (agendas.length <= 1) {
      onClick(agendas[0])
      return
    }

    setAnchorEl(event.currentTarget)
  }

  return (
    <>
      <IconButton onClick={handleClick}>{Icon}</IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {agendas.map((agenda) => (
          <MenuItem
            key={agenda.id}
            onClick={() => {
              setAnchorEl(null)
              agenda.onClick()
            }}
          >
            {agenda.nome}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
export default AgendaButton
